<div class="flex flex-col flex-auto min-w-0">

  <!-- Header -->
  <!-- <app-generic-breadcrumbs terminal="Applications"></app-generic-breadcrumbs> -->

  <!-- Main -->
  <div class="flex-auto p-6 sm:p-6">

    <!--loading-->
    <div *ngIf="viewState == viewStates.loading" class="w-full">
      <mat-spinner class="ml-auto mr-auto mt-5"></mat-spinner>
    </div>

    <!-- content -->
    <app-leads-analytics *ngIf="viewState == viewStates.content" applicationRoute="v1/applications" [permissionsService]="permissionsService"></app-leads-analytics>
  </div>

</div>